import { render, staticRenderFns } from "./MeasuresDueDateView.vue?vue&type=template&id=204ca94c&"
import script from "./MeasuresDueDateView.vue?vue&type=script&lang=ts&"
export * from "./MeasuresDueDateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports